<template>
  <div
    class="view">
    <HomeNavigation />

    <div
      class="content">
      <div
        class="collections-header">
        <div class="collections-header-left">
          <div class="collections-header-name">
            Manage your account
          </div>
        </div>
      </div>


      <div class="account-information">
        <div
          class="sub-header">
          Your information
        </div>
        <div class="personal-details-scrollcontainer">

          <div
            class="personal-details">
            <span class="account-subheader">
              How should we call you?
            </span>
            <b-field
              message="Optional. If not provided, we will call you by the names provided below or by your email address.">
              <input
                type="text"
                ref="name"
                class="account-input"
                :value="name"
                placeholder="Name or nickname"
                @blur="saveChanges"
                @keydown.enter="(e) => e.target.blur()" />
            </b-field>
            <span class="account-subheader">
              Names
            </span>
            <b-field>
              <input
                type="text"
                ref="firstName"
                class="account-input"
                :value="firstName"
                placeholder="First name"
                @blur="saveChanges"
                @keydown.enter="(e) => e.target.blur()" />
            </b-field>
            <b-field
              message="Both first and last name are optional.">
              <input
                type="text"
                ref="lastName"
                class="account-input"
                :value="lastName"
                placeholder="Last name"
                @blur="saveChanges"
                @keydown.enter="(e) => e.target.blur()" />
            </b-field>
            <span class="account-subheader">
              Email
            </span>
            <b-field>
              <input
                type="text"
                class="account-input account-input-disabled"
                :value="email"
                placeholder="Email"
                disabled />
            </b-field>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import HomeNavigation from '@/components/AppView/HomeNavigation.vue';

export default {
  name: 'CollectionManagement',
  components: {
    HomeNavigation,
  },
  data() {
    return {
      saving: false,
    };
  },
  computed: {
    ...mapState({
      collectionNodes: state => state.collections.collectionNodes,
      archivedCollectionNodes: state => state.collections.archivedCollectionNodes,
      selectedCollection: state => state.collections.selectedCollection,
      userId: state => state.users.internalUserId,
      name: state => state.users.userInfo.name,
      firstName: state => state.users.userInfo.firstName,
      lastName: state => state.users.userInfo.lastName,
      email: state => state.users.userInfo.email,
    }),
    allCollections() {
      return this.collectionNodes['0'] && this.collectionNodes['0'].children;
    },
  },
  methods: {
    ...mapActions({
      vMoveCollection: 'collections/moveCollection',
      addCollection: 'collections/addCollection',
      updateUser: 'users/updateUser',
    }),
    ...mapMutations({
      setHighlightDragOverCollection: 'appState/SetHighlightDragOverCollection',
      setMovingCollection: 'appState/SetMovingCollection',
    }),
    async saveChanges() {
      const updateObj = {
        name: this.$refs.name.value,
        firstName: this.$refs.firstName.value,
        lastName: this.$refs.lastName.value,
      };

      await this.updateUser(updateObj);
    },
    logout() {
      this.$store.commit('appState/SetScreenOverlayLogout');
      localStorage.removeItem('selectedCollection');
      localStorage.removeItem('sidebarWidth');
      localStorage.removeItem('collectionViewSortSetting');
      this.$auth.logout();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';
@import '~styles/fonts';
@import '~styles/layouts';

.root-container {
  overflow-y: scroll;
  height: calc(100vh - 2.875rem - 1.5rem); // minus navigation and top bar thingy
  padding-top: 2rem;
}
.container {
  max-width: none !important;
}
.view {
  position: relative;
  height: 100vh;
  max-height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
.collection-tabs {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  z-index: 5;
  border-bottom: 1px solid $primary;
  font-size: 1.25rem;
  height: 2.875rem; // (font-size * 1.5 line-height) + 0.5 padding + 1px for border
  padding: 0 0 0 0;
  vertical-align: middle;
}
.collection-tab {
  flex: 0 0 auto;
  margin: 0 0 -1px 0;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
}
.collection-tab-active {
  font-weight: 600;
}
.content {
  position: relative;
  height: 100%;
}
.collections-header {
  position: sticky;
  top: 10px;
  display: flex;
  width: 100%;
  padding: 0.125rem;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  height: 1.5rem;
  font-size: 0.7rem;
  color: rgba($black, 0.75);
  background-color: rgba($primary, 0.25);
  user-select: none;
}
.collections-header div {
  display: inline-flex;
}
.collections-header-name {
  padding-left: 0.25rem;
}
.collections-header-left {
  flex-basis: 50%;
  display: flex;
  padding-left: 2rem;
}
.account-information {
  height: calc(100% - 3.25rem); // minus subheader
}
.sub-header {
  margin-top: 1.5rem;
  font-family: $headerFont;
  font-size: 0.8rem;
  height: 1.25rem;
  width: 100%;
  border-bottom: 1px solid $primary;
  padding: 0 2rem;
  background: #ffffff;
  z-index: 1;
}
.personal-details-scrollcontainer {
  width: 100%;
  height: calc(100% - 2.75rem); // 2.75rem subheader
  padding: 0 0 2rem;
  overflow-y: auto;
}
.personal-details {
  width: 30rem;
  padding: 1rem 2.5rem;
}
.account-subheader {
  font-size: 0.9rem;
  font-family: $quattrocentoSans;
  font-variant: small-caps;
  font-style: normal;
  color: $primary-dark;
  padding: 1rem 0 0.25rem;
}
.account-input {
  outline: none;
  border: none;
  width: 100%;
  font-size: 1rem;
  line-height: 1.5rem;
  font-family: $headerFont;
  color: $black;
  border-radius: 0.25rem;
  padding: 0.15rem 0.25rem;
  background-color: rgba($primary, 0.25);
}
.account-input:hover,
.account-input:active,
.account-input:focus {
  background-color: $primary;
}
.account-input-disabled {
  background-color: rgba($primary, 0.25) !important;
}
</style>
